export interface BreakpointsTypes {
  native?: string;
  content?: string;
}
